import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    fetchEstadosLiquidaciones,
    fetchLiquidacionesBusqueda,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones
} from '../../../../actions/LiquidacionesActions';
import {
    getLiquidacionesListaSellers,
    getEstadosLiquidacionesCorrecto,
    putEliminaLiquidacionFinal,
    listSellers
} from '../../../../api/axios.js';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import LiquidacionesListItems from './LiquidacionesListItems';
import { customStyle, DropDownArrow } from "../../../../template/CustomStyle";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { fechaLimite, filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios.js';
import BigSpinner from '../../../General/BigSpinner.js';

// Wrapper para usar hooks en class component
function ListLiquidacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListLiquidaciones {...props} navigate={navigate} />;
}

const fechaFiltro = filtroMedioMes();
const fechaDesdeMinima = fechaLimite();

class ListLiquidaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lista_sellers_liquidaciones: [],
            lista_estados_liquidaciones: [],
            seller: {
                label: this.props.filtro?.seller?.label ?? "",
                value: this.props.filtro?.seller?.value ?? ""
            },
            estado: {
                label: this.props.filtro?.estado?.label ?? "",
                value: this.props.filtro?.estado?.value ?? ""
            },
            fechaDesde: this.props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: this.props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            buscaTodo: this.props.filtro?.buscaTodo ?? true,
        };
        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            //buscaTodo: true,
            //cantidadPagina: 10,
            //numeroPagina: 1
        };
    };

    componentDidMount() {
        if (this.props.liquidaciones?.length > 0) {
            return;
        }

        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;

        if (!isAuthorizedViewAll) {

            let filtroParams = {
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                idEstado: 3,
                idSeller: this.props.idSeller
            }

            this.props.fetchLiquidacionesBusqueda(filtroParams);

        } else {
            if (this.props.isFilterClear) {
                this.buscarSinFiltro();
            } else {
                this.buscarConFiltro();
            }
        }
    }

    buscarSinFiltro = () => {
        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;

        if (!isAuthorizedViewAll) {
            let request = {
                fechaDesde: this.INITIAL_REQUEST.fechaDesde,
                fechaHasta: this.INITIAL_REQUEST.fechaHasta,
                idEstado: 3, //harcodeado para Liquidada
                idSeller: this.props.idSeller // Force own seller
            }
            this.props.fetchLiquidacionesBusqueda(request);
        } else {
            this.props.fetchLiquidacionesBusqueda({ ...this.INITIAL_REQUEST });
            this.props.setFiltroLiquidaciones({ ...this.INITIAL_REQUEST });
        }
    }

    buscarConFiltro = () => {
        let filtroParams = {
            fechaDesde: this.props.filtro.fechaDesde,
            fechaHasta: this.props.filtro.fechaHasta,
            // seller: this.props.filtro.seller,}
            idSeller: this.props.filtro.seller ?? this.props.idSeller,
            estado: this.props.filtro.estados,
            //buscaTodo: this.props.filtro?.buscaTodo === true ? 1 : 0
        }

        this.props.fetchLiquidacionesBusqueda(filtroParams);

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    onLiquidacion = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/Editar/${idLiquidacion}/${idSeller}`);
    }

    onLiquidacionEditable = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/EditarBorrador/${idLiquidacion}/${idSeller}`);
    }

    goToCrearLiquidacion = () => {
        this.props.navigate("/Liquidaciones/Nueva");
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onChangeCheckbox = async (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked });

        this.props.setFiltroLiquidaciones({
            ...this.props.filtroLiquidaciones,
            [name]: checked
        });
    }

    eliminarLiquidacion = (idLiquidacion) => {

        let request = { IdLiquidacion: idLiquidacion };
        let post = putEliminaLiquidacionFinal(request);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La liquidación fue eliminada con éxito");
        }).catch(err => {
            toast.error("No pudimos eliminar la liquidación");
        });
    }

    onSubmit = (event) => {
        event.preventDefault();

        const { fechaDesde, fechaHasta, buscaTodo, seller = {}, estado = {} } = this.state;
        const { tipoUsuario, filtro, idSeller } = this.props;

        const isAuthorizedViewAll = tipoUsuario === 1 || tipoUsuario === 2 || tipoUsuario === 8;

        // Caso para usuarios restringidos (solo ven lo suyo)
        if (!isAuthorizedViewAll) {
            const request = {
                fechaDesde,
                fechaHasta,
                idEstado: 3, // hardcodeado para Liquidada
                idSeller: filtro?.seller ?? idSeller,
            };

            this.props.limpiarLiquidacionesBusqueda();
            this.props.fetchLiquidacionesBusqueda(request);
            this.setLimpiarFiltroFalse();
            return;
        }

        // Validaciones comunes
        if (!fechaDesde) {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (!fechaHasta) {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        // Actualizar filtro global
        const setFiltroParams = {
            fechaDesde,
            fechaHasta,
            seller,
            estado,
        };
        this.props.setFiltroLiquidaciones(setFiltroParams);

        // Preparar request base
        const request = {
            fechaDesde,
            fechaHasta,
        };

        const sellerVacio = !seller.value;
        const estadoVacio = !estado.value;

        if (sellerVacio && estadoVacio) {
            Object.assign(request, {
                //buscaTodo: 1,
                //idSeller: 0,
                //idEstado: 0,
            });
        } else {
            // if (sellerVacio) {
            //     toast.warn("Seleccione un Seller");
            //     return;
            // }

            // if (estadoVacio) {
            //     toast.warn("Seleccione un Estado");
            //     return;
            // }

            Object.assign(request, {
                //buscaTodo: 0,
                idSeller: seller.value,
                idEstado: estado.value,
            });
        }

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchLiquidacionesBusqueda(request);
        this.setLimpiarFiltroFalse();
    };


    onClear = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            ...prevState,
            ...this.INITIAL_REQUEST
        }));
        this.buscarSinFiltro();
    };

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            });
            this.setState({ lista_sellers_liquidaciones: listaTipo });
        })
    }

    mapEstados = () => {

        getEstadosLiquidacionesCorrecto().then(res_estados => {
            let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            })
            this.setState({
                lista_estados_liquidaciones: listaEstado
            })
        });
    }

    render() {
        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;
        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;

        return (
            <div className="container">
                <div className="row justify-content-between">

                    <div className="col-12 col-md-4">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Liquidación</h4>
                    </div>

                    {isAuthorizedViewAll && (
                        <div className="col-12 col-md-2 text-end">
                            <button
                                onClick={this.goToCrearLiquidacion}
                                type="button"
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle" /> Crear Liquidación
                            </button>
                        </div>
                    )}

                    <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit} onReset={this.onClear}>
                        <div className="card">
                            <div className="card-body p-4">

                                <div className="row justify-content-between">
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Desde</p>
                                        <input
                                            type="date"
                                            name="fechaDesde"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={fechaDesdeMinima}
                                            value={this.state.fechaDesde}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">
                                        <p className="font-bold">Hasta</p>
                                        <input
                                            type="date"
                                            name="fechaHasta"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={this.state.fechaDesde}
                                            value={this.state.fechaHasta}
                                        />
                                    </div>

                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2 d-inline-block">

                                            <p className="font-bold">Seller</p>
                                            <Select
                                                value={this.state.seller}
                                                options={this.state.lista_sellers_liquidaciones}
                                                onChange={this.selectSearchHandlerLiquidacionesSeller}
                                                onMenuOpen={this.mapSellers}
                                                styles={customStyle}
                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                            />
                                        </div>
                                    )}

                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2 d-inline-block">

                                            <p className="font-bold">Estados</p>
                                            <Select
                                                value={this.state.estado}
                                                options={this.state.lista_estados_liquidaciones}
                                                onChange={this.selectSearchHandlerLiquidacionesEstado}
                                                onMenuOpen={this.mapEstados}
                                                styles={customStyle}
                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                            />
                                        </div>
                                    )}

                                    {/* {!(this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4) && (
                                        <div className="col-12 col-md-8 d-inline-block mt-4">
                                            <input
                                                name="buscaTodo"
                                                type="checkbox"
                                                className="mx-2"
                                                onChange={this.onChangeCheckbox}
                                                checked={this.state.buscaTodo} 
                                            />
                                            <label htmlFor="BuscaTodo">
                                                Todas las liquidaciones de todos los sellers en el rango de tiempo
                                            </label>
                                        </div>
                                    )} */}

                                    <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                                        <button
                                            type="submit"
                                            id="botonBuscar"
                                            className="btn btn-sm background-rojo-megatone"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Buscar
                                        </button>

                                        <button
                                            type="reset"
                                            id="botonReset"
                                            className="btn btn-sm btn-grey ms-2 ms-sm-2 mt-2 mt-sm-0"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div hidden={!this.props.isLoadingLiquidaciones}>
                        <BigSpinner />
                    </div>

                    <div className="container" hidden={this.props.isLoadingLiquidaciones}>
                        {
                            liquidaciones.length === 0 ?

                                <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                                    NO SE ENCONTRARON RESULTADOS
                                </h5>

                                :

                                <LiquidacionesListItems
                                    liquidaciones={liquidaciones}
                                    onLiquidacionFunction={this.onLiquidacion}
                                    onLiquidacionEditableFunction={this.onLiquidacionEditable}
                                    eliminarLiquidacionFunction={this.eliminarLiquidacion}
                                />
                        }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    filtro: state.liquidaciones.filtro,
    isFilterClear: state.general.limpiar.liquidaciones,
    emptyFilters: state.general.limpiar,
    idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {
    fetchLiquidacionesListaSellers,
    limpiarLiquidacionesBusqueda,
    fetchLiquidacionesBusqueda,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    limpiarFiltros
})(ListLiquidacionesWrapper);